__turbopack_context__.v({
  "heroWithSearch": "HeroWithSearch-module-scss-module__srMuLG__heroWithSearch",
  "subtitle": "HeroWithSearch-module-scss-module__srMuLG__subtitle",
  "title": "HeroWithSearch-module-scss-module__srMuLG__title",
});
